export default function Impressum() {
  return (
    <div id="RootRoot" className="flex w-full flex-col items-start justify-end">
      <h1 className="py-16">Impressum</h1>
      <dl className="text-lg">
        <dt className="font-bold">CaboCheck ist eine Marke der:</dt>
        <dd>Healyzer Health Analyzing Technologies GmbH</dd>
        <dd>Zimmerpforte 3</dd>
        <dd className="pb-8">20099 Hamburg</dd>
        <dd className="pb-8">Eingetragen beim Amtsgericht Hamburg: HRB 178932</dd>
        <dd className="pb-8">V.i.s.d.P. Marc-Andre Röske</dd>
        <dd>Tel. 040 / 33468780</dd>
        <dd className="pb-8">eMail: info@cabocheck.com</dd>
        <dd>USt. ID: DE332748194</dd>
      </dl>
    </div>
  );
}
